import React, { Component } from "react";
import { connect } from "react-redux";
import { Tabs, Card, Button, Table, Alert } from "antd";
import {
  req_single_cms_school_student,
  req_single_cms_learnmap_yearplan,
  req_single_cms_learnmap_talents_occupation,
} from "../../api";

const { TabPane } = Tabs;
class CoursemapStudentOccupation extends Component {
  // 初始化作業 ///////////////////////////////////////////////
  state = {
    items: [],
    deviceWidth: 0,
    loading: false,
  };

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_init_items();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }
  // 遠端數據處理 //////////////////////////////////////////////
  api_init_items = async () => {
    const { userCode, token } = this.props.user;
    this.setState({ loading: true, items: [] });
    const result = await req_single_cms_school_student(userCode, token);
    //console.log(result)
    if (result) {
      const yearplan = await req_single_cms_learnmap_yearplan(result, token);
      //console.log(yearplan)
      if (yearplan) {
        const { gidLearnMapMeta } = yearplan;
        const talentsoccupation =
          await req_single_cms_learnmap_talents_occupation(
            gidLearnMapMeta,
            token
          );
        if (talentsoccupation.total > 0) {
          //console.log(talentsoccupation.data);
          const items = talentsoccupation.data;
          this.setState({ items });
        }
      }
    }
    this.setState({ loading: false });
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading, items, deviceWidth } = this.state;
    const manpowerBank = "https://www.104.com.tw/jobs/search/?ro=1&jobcat=";
    const columns = [
      {
        title: "職業",
        dataIndex: "jobName",
        width: 20,
      },
      {
        title: "類別",
        dataIndex: "jobContent",
        width: 60,
        responsive: ["md"],
      },
      {
        title: "連結",
        width: 20,
        render: (item) => {
          const { id, manpowerBankJobCode } = item;
          return (
            <div className="text-center">
              <a
                className="btn btn-primary btn-sm"
                href={manpowerBank + manpowerBankJobCode}
                target="_blank"
                rel="noreferrer"
                size="small"
                key={id}
              >
                <i className="fas fa-search" style={{ marginRight: "2px" }}></i>{" "}
                連結104查詢
              </a>
            </div>
          );
        },
      },
    ];
    const htmlItems =
      items.length > 0
        ? items.map((d, idx) => (
            <>
              <TabPane tab={d.talentTwName} key={idx}>
                <Alert
                  description={d.talentDescription}
                  type="success"
                  showIcon
                />
                {deviceWidth > 800 ? (
                  <div className="row">
                    {d.occupationItems.length > 0 ? (
                      <Card key={idx}>
                        <Table
                          bordered
                          style={{ width: "99%" }}
                          scroll={{ y: 500 }}
                          loading={loading}
                          rowKey="id"
                          dataSource={d.occupationItems}
                          pagination={false}
                          columns={columns}
                        />
                      </Card>
                    ) : (
                      <Alert
                        message="無相關資訊(此功能僅適用日四技查詢)"
                        type="warning"
                        closable
                      />
                    )}
                  </div>
                ) : (
                  <div className="row">
                    {d.occupationItems.length > 0 ? (
                      d.occupationItems.map((t, idt) => (
                        <>
                          <div
                            className="col-sm col-md-4"
                            style={{ marginTop: "5px" }}
                          >
                            <Card
                              key={idt}
                              title={
                                <>
                                  <i className="fas fa-user-tag"></i>{" "}
                                  {t.jobName}
                                </>
                              }
                              style={{
                                backgroundColor: "rgba(255, 255, 255, 0.0)",
                                border: 0,
                              }}
                              headStyle={{
                                backgroundColor: "rgba(75, 28, 90, 0.4)",
                                border: 0,
                              }}
                              bodyStyle={{
                                backgroundColor: "rgba(248, 225, 255, 0.4)",
                                border: 0,
                              }}
                              extra={
                                <Button
                                  type="primary"
                                  shape="round"
                                  href={manpowerBank + t.manpowerBankJobCode}
                                  target="_blank"
                                  rel="noreferrer"
                                  size="small"
                                >
                                  <i
                                    className="fas fa-search"
                                    style={{ marginRight: "2px" }}
                                    key={idt}
                                  ></i>{" "}
                                  連結104查詢
                                </Button>
                              }
                            >
                              {t.jobContent}
                            </Card>
                          </div>
                        </>
                      ))
                    ) : (
                      <Alert
                        message="無相關資訊(此功能僅適用日四技查詢)"
                        type="warning"
                        closable
                      />
                    )}
                  </div>
                )}
              </TabPane>
            </>
          ))
        : "";

    return (
      <>
        {loading ? (
          <div className="text-center">
            <p />
            <button className="btn " type="button" disabled>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                style={{ marginRight: "4px" }}
              ></span>
              Loading...
            </button>
          </div>
        ) : (
          <>
            <Tabs defaultActiveKey="0">
              {items.length > 0 ? (
                htmlItems
              ) : (
                <div
                  className="alert alert-info"
                  role="alert"
                  style={{ width: "100%" }}
                >
                  查無相關數據
                </div>
              )}
            </Tabs>
          </>
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(CoursemapStudentOccupation);
